export default {
    mapper: {
        relations: {
            belongsTo: {
                document: {
                    foreignKey: 'document_id',
                    localField: 'document',
                },
            },
            morphTo: {
                documentProcessingEvent: {
                    foreignKey: 'source_id',
                    localField: 'source',
                },
            },
        },
    },
};
